<div [ngSwitch]="status">
  <div *ngSwitchCase="enumQStatus.Respond" class="status-q respond">
    <img src="/assets/images/grid/status/answered.svg">
    <!-- <p translate>grid.status.replay</p> -->
    <div class="warp-responed flex-direction-revers-by-dir-he">
      <p>{{countAnswered}}</p>
      <p>/</p>
      <p>{{countAllRecipients}}</p>
    </div>
  </div>
  <div *ngSwitchCase="enumQStatus.Distributed" class="status-q distributed">
    <img src="/assets/images/grid/status/distributed.svg">
    <p translate>grid.status.distributed</p>
  </div>
  <div *ngSwitchCase="enumQStatus.Edit" class="status-q edit">
    <img src="/assets/images/grid/status/edit.svg">
    <p translate> grid.status.edit</p>
  </div>
</div>

<div [ngSwitch]="statusApproval">
  <div *ngSwitchCase="enumApprovalStatus.Rejected" class="status-q rejected">
    <img src="/assets/images/grid/status/cancel.svg">
    <p>{{'grid.status.rejected' | translate}}</p>
  </div>
  <div *ngSwitchCase="enumApprovalStatus.Approved" class="status-q approved">
    <img src="/assets/images/grid/status/check_circle.svg">
        <p>{{'grid.status.approved' | translate}}</p>

  </div>
  <!-- Reports' "view" action forwards a still-pending request as PendingPrevApproval so the header
       renders a badge instead of the approve/reject buttons (see formStatusToApprovalStatus).
       Without this case that viewer saw an empty status area. -->
  <div *ngSwitchCase="enumApprovalStatus.PendingPrevApproval" class="status-q pending-approval">
    <img src="/assets/images/grid/status/hourglass.svg">
    <p>{{'grid.status.pendingApproval' | translate}}</p>
  </div>
</div>